module.exports = __webpack_public_path__ + "media/images/scoreBet__inProgress-55ceb65cd7aceca9bcaa575313776717.png";